<template>
  <div class="container-fluid d-flex flex-column">
    <h4 class="d-flex mt-3">
      "MTN Digital Fantasy Games" - Terms and Conditions
    </h4>

    <div class="d-flex mt-3">
      <b>Organizing Entity: MTN Nigeria</b>
    </div>

    <div class="d-flex mt-3">
      The Organizer reserves the right to cancel or amend these Terms and Conditions at any time. Any changes will be
      posted online at the Organizer’s website.
    </div>

    <div class="d-flex mt-3">
      <b>1) Service Description</b>
    </div>
    <div class="d-flex px-2">
      1.1. MTN Nigeria (the Organizer) and Rembrandt Global Solutions Limited (the Provider) will launch an SMS and
      Interactive Web-based Game for the Organizer’s customers. The service will be based on a Premium subscription
      (daily subscription cost NGN 150/day), which will enable the participant to play with:
    </div>
    <div class="d-flex px-3">
      ● An SMS-based Premium Trivia Game, consisting in a set of 5 questions and answers about sports news, scores and
      general information, which the subscriber will be invited to reply to, and
    </div>
    <div class="d-flex px-3">
      ● A WAP/WEB-based Premium Interactive Web Game, providing the end user with the ability to pick their favorite
      players from the biggest teams across the world, enter multiple contests daily and weekly across leagues, and view
      various information including player/team news and scores.
    </div>
    <div class="d-flex px-2">
      1.2. Participants will be invited to play the Service to earn points and have fun.
    </div>
    <div class="d-flex px-2">
      1.3. Upon successful daily charge, Participants will be provided with a:
    </div>
    <div class="d-flex px-3">
      ● Charging confirmation message, confirming the entry accrual due to successful charge, and containing the
      hyperlink to access the Game Portal, and
    </div>
    <div class="d-flex px-3">
      ● Daily SMS query, by replying to which end users will trigger the SMS trivia game start.
    </div>

    <div class="d-flex mt-3">
      <b>2) Registration and Cancellation</b>
    </div>
    <div class="d-flex px-2">
      1) To register and become a Participant, end users will be required to send an SMS with a valid registration
      keyword (e.g., OK, YES, GO) to the short code 32708, or dial the USSD code *32708#, or confirm willingness to
      participate by replying [OK] to the SAT Push advertising messages.
    </div>
    <div class="d-flex px-2">
      2) Additional registration requests might be added from time to time during the duration at sole discretion of the
      Organizer.
    </div>
    <div class="d-flex px-2">
      3) Participants will be able to cancel their subscription at any time by sending a free-of-charge SMS with the
      keyword STOP to the short code 32708.
    </div>
    <div class="d-flex px-2">
      4) Participants will also be able to cancel their subscription by calling MTN Call Center on 180 and asking for
      unsubscription.
    </div>
    <div class="d-flex px-2">
      5) Participants’ subscription might be canceled at the sole discretion of the Organizer in the event a clear
      expression of non-interest in participating is demonstrated via SMS communication (e.g., the Participant sends “I
      do not want to participate”).
    </div>
    <div class="d-flex px-2">
      6) In case of repeated unsuccessful charges, at the sole discretion of the Organizer, Participants might be
      removed from the service.
    </div>
    <div class="d-flex px-2">
      7) Participants who canceled their subscription can re-register at any given point in time by sending the defined
      registration keyword(s) to the dedicated short code, or by any other valid registration flow.
    </div>
    <div class="d-flex px-2">
      8) The Organizer reserves the right to prevent access to the service to specific subsets of the customer base.
    </div>

    <div class="d-flex mt-3">
      <b>3) Subscription Charges</b>
    </div>
    <div class="d-flex px-2">
      1) The daily subscription charge will be NGN 150/day (incl. Tax). Every day, Participants will be charged via the
      daily billing cycle that runs while a subscription is active.
    </div>
    <div class="d-flex px-2">
      2) The Organizer may offer the Premium subscription at its sole discretion from time to time at a discounted rate
      of ₦100 (NGN) daily OR ₦80 (NGN) daily OR ₦50 (NGN) daily OR ₦30 (NGN) daily OR ₦5 (NGN) daily.
    </div>
    <div class="d-flex px-2">
      3) All SMS interactions Participants with the Service will be free of charge.
    </div>
    <div class="d-flex px-2">
      4) All web sessions users using the game portal will be charged according to the standard operator data rates.
    </div>

    <div class="d-flex mt-3">
      <b>4) Abuse and Disqualification</b>
    </div>
    <div class="d-flex px-2">
      Participants will not be allowed to use machines that automatically send SMS messages or
      automate/facilitate the answer/gaming process, or any other alternative of sending SMS messages, other
      than the mobile phone (this prohibits the use of any GSM modems attached to a computer or mobile
      phones attached to a computer). The Organizer reserves the right to disqualify any Participant under the
      suspicion of breaking this obligation.
    </div>

    <div class="d-flex mt-3">
      <b>5) Organizer’s Responsibilities</b>
    </div>
    <div class="d-flex px-2">
      The Organizer is not responsible for delays or failures in SMS delivery or billing due to technical issues. SMS logs
      in the Organizer's system serve as proof of sent/received messages.
    </div>

    <div class="d-flex mt-3">
      <b>6) Personal Data Protection</b>
    </div>
    <div class="d-flex px-2">
      All personal data collected will be treated confidentially in accordance with Nigerian data protection laws. It
      will not be shared unless legally required or explicitly authorized by the Participant.
    </div>

    <div class="d-flex mt-3">
      <b>7) Governing Law & Amendments</b>
    </div>
    <div class="d-flex px-2">
      This Service is governed by the laws of the Federal Republic of Nigeria. These Terms & Conditions remain in effect
      during the Service Period unless amended or suspended by the Organizer.
    </div>
  </div>
</template>

<script>
export default {
  name: "NigeriaFantasyTerms",
};
</script>

<style scoped>
.table-fit-screen {
  font-size: x-small !important;
}
</style>
